import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

class CarsActiveTableRow extends Component {
  constructor () {
    super();
    this.state = {
      checked: false
    };
  }
  componentWillMount() {
    // console.log(this.props.car);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selctAllRowsStatus !== nextProps.selctAllRowsStatus) {
      if (nextProps.selctAllRowsStatus !== this.state.checked) this.inputElement.click();
    }
  }
carSelectHandle = () => {
  this.props.loadCarData(this.props.car);
  this.props.SetActionPage('carData');
}
Year = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.year) {
    return carItem.listings.build.year;
  }
  return 'no data';
};
CarModel = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.model) {
    return carItem.listings.build.model;
  }
  return 'no data';
};
Manufacturer = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.make) {
    return carItem.listings.build.make;
  }
  return 'no data';
};
Type = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.body_type) {
    return carItem.listings.build.body_type;
  }
  return 'no data';
};
Mileage = () => {
  const carItem = this.props.car;
  if (carItem.listings.miles) {
    return carItem.listings.miles;
  }
  return 'no data';
};
Transmission = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.transmission) {
    return carItem.listings.build.transmission;
  }
  return 'no data';
};
FuelType = () => {
  const carItem = this.props.car;
  if (carItem.listings.build.fuel_type) {
    return carItem.listings.build.fuel_type;
  }
  return 'no data';
};
VehicteCost = () => {
  const carItem = this.props.car;
  if (carItem.listings.price) {
    return carItem.listings.price;
  }
  return 'no data';
};
img = () => {
  const carItem = this.props.car;
  if (carItem.listings.vdp_url) {
    return carItem.listings.vdp_url;
  }
  return 'no data';
};
toggleCheckbox = (e) => {
  // eslint-disable-next-line
  this.props.formingDeleteArray(e.target.checked, this.props.car['_id']);
  this.setState({
    checked: e.target.checked
  });
}
render() {
  return (
    <div className={`body-CarsActiveTableRow ${this.state.checked ? 'cheked' : ''}`}>
      <div className="cell-CarsActiveTableRow">

        <input
          ref={(el) => { this.inputElement = el; return this.inputElement; }}
          id={
          // eslint-disable-next-line
        this.props.car['_id']
        }
          type="checkbox"
          onChange={this.toggleCheckbox}
        />
        <label
          htmlFor={
            // eslint-disable-next-line
            this.props.car['_id']
            }
        ><span />
        </label>
      </div>
      {/* <div className="cell-CarsActiveTableRow">Activity</div>
      <div className="cell-CarsActiveTableRow">ID</div> */}
      <div className="cell-CarsActiveTableRow">
        <div className="imgContainet-CarsActiveTableRowImg">
          <img className="cell-CarsActiveTableRowImg" src={this.img()} alt="pic" />
          <button className="selCarButton-CarsActiveTableRowImg" onClick={this.carSelectHandle}>
            {this.Manufacturer()}
            {' '}
            {this.CarModel()}
            {' `'}
            {((this.Year()).toString()).slice(-2)}
          </button>
        </div>
      </div>
      <div className="cell-CarsActiveTableRow">{this.Type()}</div>
      <div className="cell-CarsActiveTableRow">{this.Manufacturer()}</div>
      <div className="cell-CarsActiveTableRow">{this.CarModel()}</div>
      <div className="cell-CarsActiveTableRow">{this.Year()}</div>
      <div className="cell-CarsActiveTableRow">{this.Mileage()}</div>
      <div className="cell-CarsActiveTableRow">{this.Transmission()}</div>
      <div className="cell-CarsActiveTableRow">{this.FuelType()}</div>
      <div className="cell-CarsActiveTableRow">{this.VehicteCost()}</div>
    </div>
  );
}
}

CarsActiveTableRow.defaultProps = {
  car: {},
  selctAllRowsStatus: null
};

CarsActiveTableRow.propTypes = {
  car: PropTypes.instanceOf(Object),
  formingDeleteArray: PropTypes.func.isRequired,
  SetActionPage: PropTypes.func.isRequired,
  loadCarData: PropTypes.func.isRequired,
  selctAllRowsStatus: PropTypes.bool
};
export default CarsActiveTableRow;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carActiveTableRow/index.js